import request from '../../untils/request';

// 查询
export function detail(data) {
  return request({
    url: '/systemCustomConfig/detail2',
    method: 'get',
    params: data,
  });
}

// 保存
export function sava(data) {
  return request({
    url: '/systemCustomConfig',
    method: 'post',
    data: data,
  });
}
